import React from "react";
import { Box, Container, Typography } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import { COLORS, FONT } from "../../constants";
import useSystemHook from "../../hooks/SystemHook";

const STEP_ICONS = {
  Application: (
    <AssignmentOutlinedIcon sx={{ fontSize: 32, color: COLORS.themeYellow }} />
  ),
  Registration: (
    <LanguageOutlinedIcon sx={{ fontSize: 32, color: COLORS.themeYellow }} />
  ),
  Approval: (
    <HowToRegOutlinedIcon sx={{ fontSize: 32, color: COLORS.themeYellow }} />
  ),
  Ordering: (
    <AddShoppingCartOutlinedIcon
      sx={{ fontSize: 32, color: COLORS.themeYellow }}
    />
  ),
};

const HowItWorks = ({ steps }) => {
  const { isMobile } = useSystemHook();

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: COLORS.white,
        py: isMobile ? 6 : 8,
        overflow: "hidden",
      }}
    >
      {/* Abstract automotive background art */}
      <SettingsOutlinedIcon
        sx={{
          position: "absolute",
          top: -70,
          left: -70,
          fontSize: 300,
          color: COLORS.themeBlack,
          opacity: 0.07,
          pointerEvents: "none",
          userSelect: "none",
        }}
      />
      <SettingsOutlinedIcon
        sx={{
          position: "absolute",
          bottom: -90,
          right: -50,
          fontSize: 260,
          color: COLORS.themeBlack,
          opacity: 0.06,
          pointerEvents: "none",
          userSelect: "none",
        }}
      />
      <BuildOutlinedIcon
        sx={{
          position: "absolute",
          top: 10,
          right: "22%",
          fontSize: 140,
          color: COLORS.themeBlack,
          opacity: 0.05,
          transform: "rotate(-35deg)",
          pointerEvents: "none",
          userSelect: "none",
        }}
      />
      <SpeedOutlinedIcon
        sx={{
          position: "absolute",
          bottom: 0,
          left: "38%",
          fontSize: 120,
          color: COLORS.themeBlack,
          opacity: 0.05,
          pointerEvents: "none",
          userSelect: "none",
        }}
      />
      <SettingsOutlinedIcon
        sx={{
          position: "absolute",
          top: "30%",
          left: "48%",
          fontSize: 100,
          color: COLORS.themeBlack,
          opacity: 0.04,
          pointerEvents: "none",
          userSelect: "none",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            textAlign: "center",
            mb: 1,
            color: COLORS.themeBlack,
          }}
        >
          How It Works
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            color: COLORS.themeBlack,
            mb: 6,
            fontSize: isMobile ? FONT.size.xs : FONT.size.md,
            opacity: 0.7,
          }}
        >
          Getting started is simple — follow these four steps.
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: isMobile ? 3 : 2,
            flexWrap: isMobile ? "wrap" : "nowrap",
            justifyContent: "center",
          }}
        >
          {steps.map((step) => (
            <Box
              key={step.number}
              sx={{
                flex: "1 1 0",
                minWidth: isMobile ? "calc(50% - 12px)" : 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Box sx={{ position: "relative", mb: 2.5 }}>
                <Box
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    backgroundColor: COLORS.themeBlack,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {STEP_ICONS[step.title]}
                </Box>
                <Box
                  sx={{
                    position: "absolute",
                    top: -4,
                    right: -4,
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    backgroundColor: COLORS.themeRed,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: COLORS.white,
                      fontSize: FONT.size.xs,
                      fontWeight: 700,
                      lineHeight: 1,
                    }}
                  >
                    {step.number}
                  </Typography>
                </Box>
              </Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: isMobile ? FONT.size.sm : FONT.size.base,
                  color: COLORS.themeBlack,
                  mb: 1,
                }}
              >
                {step.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
                  color: COLORS.themeBlack,
                  opacity: 0.75,
                  lineHeight: 1.6,
                }}
              >
                {step.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default HowItWorks;
